import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EquipmentType } from 'app/types/types'

interface EquipmentModalState {
  isOpen: boolean
  equipmentType: EquipmentType
  initialData: any
  mode: 'add' | 'edit'
}

const initialState: EquipmentModalState = {
  isOpen: false,
  equipmentType: 'elevator',
  initialData: null,
  mode: 'add'
}

interface OpenModalPayload {
  equipmentType: EquipmentType
  data?: any
  mode?: 'add' | 'edit'
}

const equipmentModalSlice = createSlice({
  name: 'equipmentModal',
  initialState,
  reducers: {
    openEquipmentModal: (state, action: PayloadAction<OpenModalPayload>) => {
      state.isOpen = true
      state.equipmentType = action.payload.equipmentType
      state.initialData = action.payload.data || null
      state.mode = action.payload.mode || (action.payload.data ? 'edit' : 'add')
    },
    closeEquipmentModal: state => {
      state.isOpen = false
      state.initialData = null
      state.mode = 'add'
    },
    setEquipmentModalData: (state, action: PayloadAction<any>) => {
      state.initialData = action.payload
    },
    setEquipmentType: (state, action: PayloadAction<EquipmentType>) => {
      state.equipmentType = action.payload
    }
  }
})

export const { openEquipmentModal, closeEquipmentModal, setEquipmentModalData, setEquipmentType } =
  equipmentModalSlice.actions

export default equipmentModalSlice.reducer
